import React from 'react'
import "./NewsLetter.css"

const NewsLetter = () => {
  return (
    <div className = "newsletter">
      <h1>Get Exclusive Email Offers</h1>
      <p>SUBSCRIBE TO OUR NEWSLETTER TO STAY UPDATED</p>
      <div>
        <input type="email" placeholder='Enter your email' />
        <button>Subscribe</button>
      </div>
    </div>
  )
}

export default NewsLetter
